import React from "react";

const ALARM_URL = "alarm.wav";

export function useAlarm() {
  const audioRef = React.useRef(new Audio(ALARM_URL));
  const [isAlarmPlaying, setIsAlarmPlaying] = React.useState<boolean>(false);
  const [isAlarmLoading, setIsAlarmLoading] = React.useState<boolean>(true);

  React.useEffect(() => {
    if (isAlarmLoading) return;

    const audio = audioRef.current;
    if (isAlarmPlaying) {
      audio.play();
    } else {
      audio.currentTime = 0;
      audio.pause();
    }
  }, [isAlarmPlaying, isAlarmLoading]);

  React.useEffect(() => {
    function handleStopPlaying() {
      setIsAlarmPlaying(false);
    }

    const audio = audioRef.current;

    audio.addEventListener("ended", handleStopPlaying);
    return () => {
      audio.removeEventListener("ended", handleStopPlaying);
    };
  }, []);

  React.useEffect(() => {
    function handleAudioLoad() {
      setIsAlarmLoading(false);
    }

    const audio = audioRef.current;

    audio.addEventListener("canplaythrough", handleAudioLoad);
    return () => {
      audio.removeEventListener("canplaythrough", handleAudioLoad);
    };
  }, []);

  return { isAlarmPlaying, setIsAlarmPlaying, isAlarmLoading };
}
